import classNames from 'classnames';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import bindAll from 'lodash.bindall';
import React from 'react';
import { defineMessages, FormattedMessage, intlShape, injectIntl } from 'react-intl';

import BufferedInputHOC from '../forms/buffered-input-hoc.jsx';
import Input from '../forms/input.jsx';
const BufferedInput = BufferedInputHOC(Input);


import styles from './project-title-input.css';
import { setProjectTitle } from '../../reducers/project-title.js';

const messages = defineMessages({
    projectTitlePlaceholder: {
        id: 'gui.gui.projectTitlePlaceholder',
        description: 'Placeholder for project title when blank',
        defaultMessage: 'Project title here'
    }
});

class ProjectTitleInput extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleUpdateProjectTitle'
        ]);
    }
    // call onUpdateProjectTitle if it is defined (only defined when gui
    // is used within scratch-www)
    handleUpdateProjectTitle(newTitle) {
        // switch (true) {
        //     case (isNaN(newTitle.substr(0, 1)) === false && newTitle.indexOf(' ') === -1):
        //         // 首字符为数字 没有空格
        //         document.getElementsByClassName('project-title-input_titleWrap_fw3Zd')[0].children[1].style.display = 'block';
        //         document.getElementsByClassName('input_input-form_2EIqD')[0].style.border = '1px solid red';
        //         document.getElementsByClassName('project-title-input_titleWrap_fw3Zd')[0].children[2].style.display = 'none';
        //         document.getElementsByClassName('project-title-input_titleWrap_fw3Zd')[0].children[3].style.display = 'none';
        //         break;
        //     case (isNaN(newTitle.substr(0, 1)) === false && newTitle.indexOf(' ') !== -1):
        //         // 首字符为数字 含有空格
        //         document.getElementsByClassName('project-title-input_titleWrap_fw3Zd')[0].children[3].style.display = 'block';
        //         document.getElementsByClassName('input_input-form_2EIqD')[0].style.border = '1px solid red';
        //         document.getElementsByClassName('project-title-input_titleWrap_fw3Zd')[0].children[1].style.display = 'none';
        //         document.getElementsByClassName('project-title-input_titleWrap_fw3Zd')[0].children[2].style.display = 'none';
        //         break;
        //     case (isNaN(newTitle.substr(0, 1)) === true && newTitle.indexOf(' ') !== -1):
        //         // 首字符不为数字 含有空格
        //         document.getElementsByClassName('project-title-input_titleWrap_fw3Zd')[0].children[1].style.display = 'none';
        //         document.getElementsByClassName('project-title-input_titleWrap_fw3Zd')[0].children[3].style.display = 'none';
        //         document.getElementsByClassName('input_input-form_2EIqD')[0].style.border = '1px solid red';
        //         document.getElementsByClassName('project-title-input_titleWrap_fw3Zd')[0].children[2].style.display = 'block';
        //         break;
        //     case (isNaN(newTitle.substr(0, 1)) === true && newTitle.indexOf(' ') === -1):
        //         // 首字符不为数字 没有空格
        //         document.getElementsByClassName('input_input-form_2EIqD')[0].style.border = '1px dashed hsla(0, 0%, 0%, 0.15)';
        //         document.getElementsByClassName('project-title-input_titleWrap_fw3Zd')[0].children[1].style.display = 'none';
        //         document.getElementsByClassName('project-title-input_titleWrap_fw3Zd')[0].children[2].style.display = 'none';
        //         document.getElementsByClassName('project-title-input_titleWrap_fw3Zd')[0].children[3].style.display = 'none';
        //         break;

        // }
        if (this.props.onUpdateProjectTitle) {
            this.props.onUpdateProjectTitle(newTitle);
        }
    }
    render() {
        return (
            <div
                className={classNames(styles.titleWrap)}
            >
                <BufferedInput
                    className={classNames(styles.titleField, this.props.className)}
                    maxLength="100"
                    placeholder={this.props.intl.formatMessage(messages.projectTitlePlaceholder)}
                    tabIndex="0"
                    type="text"
                    value={this.props.projectTitle}
                    onSubmit={this.handleUpdateProjectTitle}
                    setprojectTitle={this.props.onUpdateReduxProjectTitle}
                />
                {
                    this.props.isCorrect === 1 ?
                        <FormattedMessage
                            defaultMessage="The first character cannot be a number"
                            description="tip for title name"
                            id="gui.menuBar.titleTip"
                        /> : this.props.isCorrect === 2 ?
                            <FormattedMessage
                                defaultMessage="The first character cannot be a number"
                                description="tip for title name"
                                id="gui.menuBar.nospace"
                            /> : this.props.isCorrect === 3 ?
                                <FormattedMessage
                                    defaultMessage="The first character cannot be a number"
                                    description="tip for title name"
                                    id="gui.menuBar.numAndspace"
                                /> : null
                }
            </div>
        );
    }
}

ProjectTitleInput.propTypes = {
    className: PropTypes.string,
    intl: intlShape.isRequired,
    onUpdateProjectTitle: PropTypes.func,
    projectTitle: PropTypes.string
};

const mapStateToProps = state => ({
    projectTitle: state.scratchGui.projectTitle.title,
    isCorrect: state.scratchGui.projectTitle.isCorrect
});

const mapDispatchToProps = (dispatch) => ({
    onUpdateReduxProjectTitle: title => dispatch(setProjectTitle(title))
});

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectTitleInput));
